<template>
    <div class="recommend-spec-box" @click="onClick(item.id)">
    <div class="spec-box-top">
      <van-image class="spec-pic" round :src="item.avatar+'?x-oss-process=image/resize,l_200'" fit="cover"></van-image>
    </div>
    <div class="spec-info">
      <div class="spec-name">{{ item.nickname }}</div>
      <div class="spec-post">{{ item.title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'artist-item',
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    titleList () {
      return this.item.titleList.split(',').splice(0, 3)
    }
  },
  methods: {
    onClick (id) {
      this.$emit('click', id)
    }
  }
}
</script>

<style lang="scss" scoped>
.recommend-spec-box {
  margin-top: 20px;
  text-align: center;
position: relative;

.spec-box-top {
    width: 74px;
    border-radius: 2px;
    margin: 0 auto;

    .spec-pic {
    width: 74px;
    height: 74px;
    }
}

.spec-info {
    width: 130px;
    padding-top: 10px;

    .spec-name {
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    margin-bottom: 10px;
    line-height: 1;
    }

    .spec-post {
    margin-bottom: 7px;
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #727272;
    line-height: 1.5;
    /* 超出部分使用省略号 */
    text-overflow: -o-ellipsis-lastline;
    /* 超出部分隐藏 */
    overflow: hidden;
    /* 超出部分使用省略号 */
    text-overflow: ellipsis;
    /* 设置布局 */
    display: -webkit-box;
    /* 控制显示 */
    -webkit-line-clamp: 2;
    /* 控制显示行数 */
    line-clamp: 2;
    -webkit-box-orient: vertical;
    /* 设置英文，数字不换行 */
    word-break: break-all;
    white-space: normal;
    }
}

.spec-next {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 10px;
    height: 10px;
}
  }
</style>
